import type { ISubjectDto, ISubjectResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createDeleteApi } from "@api/util/createDeleteApi";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ISubjectResponse>>,
  IPathBaseParam,
  IPaginationParams
>("subjects");
const postApis = createPostApi<
  IApiResponse<ISubjectResponse>,
  IPathBaseParam,
  ISubjectDto
>("subjects");
const getApis = createGetApi<
  IApiResponse<ISubjectResponse>,
  IPathByIdParam,
  object
>("subjects");
const patchApis = createPatchApi<
  IApiResponse<ISubjectResponse>,
  IPathByIdParam,
  ISubjectDto
>("subjects");
const deleteApis = createDeleteApi<
  IApiResponse<ISubjectResponse>,
  IPathByIdParam
>("subjects");

export const subjects = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
};
